/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonBase from '@material-ui/core/ButtonBase';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    width: '17.875rem',
    height: '4rem',
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    // backgroundColor: theme.palette.cardActive,
    // boxShadow: '0px 1px 3px rgba(63, 63, 68, 0.15)',
    borderRadius: '.25rem',
    '&--active': {
      backgroundColor: theme.palette.cardActive,
    },
  },
  container: {
    padding: 0,
    margin: '.5rem',
  },
  title: {
    display: 'block',
    fontSize: 'initial',
    fontWeight: '600',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    display: 'block',
    fontSize: 'initial',
    color: theme.palette.input,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default function FilesSelectorOption({ title, subtitle, isActive, onClick }) {
  const classes = useStyles();

  return (
    <MenuItem className={classes.container}>
      <ButtonBase
        className={clsx(classes.root, isActive ? `${classes.root}--active` : null)}
        onClick={onClick}
        aria-controls="filePreview"
      >
        <span className={classes.title}>{title}</span>
        <span className={classes.subtitle}>{subtitle}</span>
      </ButtonBase>
    </MenuItem>
  );
}
